'use client';

import { createContext, useContext, type ReactNode } from 'react';
import { useSearchParams } from 'next/navigation';
import { useInternalPathname } from 'hooks/navigation/useInternalPathname';
import { useRegionLocale } from 'contexts/RegionLocaleContext';
import { OPTUM_FLOW_PARAM, readFlowParam } from 'lib/partner/optumMode';
import {
  DEFAULT_PARTNER_POLICY,
  partnerPolicyFor,
  type PartnerPolicy,
} from 'lib/partner/partnerPolicy';

const PartnerModeContext = createContext<PartnerPolicy>(DEFAULT_PARTNER_POLICY);

/** Optum mode comes from the URL alone (`?flow=optum` on the US buy page), on every render. */
export function PartnerModeProvider({ children }: { children: ReactNode }) {
  const internalPath = useInternalPathname();
  const flow = readFlowParam(useSearchParams()?.get(OPTUM_FLOW_PARAM));
  const { region } = useRegionLocale();

  return (
    <PartnerModeContext.Provider
      value={partnerPolicyFor({ region, internalPath, flow })}
    >
      {children}
    </PartnerModeContext.Provider>
  );
}

export const usePartnerPolicy = (): PartnerPolicy =>
  useContext(PartnerModeContext);
